__turbopack_context__.v({
  "app_light_theme": "product-colors-module-scss-module__eimNRW__app_light_theme",
  "isCurrent": "product-colors-module-scss-module__eimNRW__isCurrent",
  "outOfStock": "product-colors-module-scss-module__eimNRW__outOfStock",
  "productColors": "product-colors-module-scss-module__eimNRW__productColors",
  "productColorsInner": "product-colors-module-scss-module__eimNRW__productColorsInner",
  "productColorsItem": "product-colors-module-scss-module__eimNRW__productColorsItem",
  "productColorsPopoverBody": "product-colors-module-scss-module__eimNRW__productColorsPopoverBody",
  "productVariantsTitle": "product-colors-module-scss-module__eimNRW__productVariantsTitle",
});
